import { useState } from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import { QuotePricingLineItemFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import Header from './Header'
import Body from './_Body'

interface QuotePhasesTableProps {
  lineItems: QuotePricingLineItemFragment[]
  isProductQuote: boolean
}
const QuotePhasesTable = ({ lineItems, isProductQuote }: QuotePhasesTableProps) => {
  const {
    company: { legalEntities, currency },
  } = useCurrentSession()
  const legalEntityMainCurrency =
    legalEntities?.find((legalEntity) => legalEntity.main)?.currency || currency || 'EUR'

  const [standaloneItems, setStandaloneItems] = useState<QuotePricingLineItemFragment[]>(lineItems)

  const handleUpdateStandaloneItem = (
    itemId: number,
    updates: Partial<QuotePricingLineItemFragment>
  ) => {
    setStandaloneItems((prev) =>
      prev.map((item) => (item.id === itemId ? { ...item, ...updates } : item))
    )
  }

  const handleAddStandaloneItem = (itemType: 'role' | 'simple') => {
    setStandaloneItems((prev) => [
      ...prev,
      {
        id: (lineItems[0]?.id || 0) + 10001,
        description: '',
        parentId: null,
        profitCents: 0,
        quantity: 0,
        quantityType: 'units',
        taxRateId: 0,
        taxRatePercentage: 0,
        taxTypeId: 0,
        taxTypeName: '',
        taxTypeType: '',
        totalCostCents: 0,
        totalPriceCents: 0,
        type: itemType,
        unitCostCents: 0,
        unitPriceCents: 0,
      },
    ])
  }

  const handleDeleteStandaloneItem = (itemId: number) => {
    setStandaloneItems((prev) => prev.filter((item) => item.id !== itemId))
  }

  return (
    <>
      <Box
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
        paddingBottom="s20"
      >
        <Text size="400" weight="semibold" color="grey1000">
          {i18n.t('finance.quotes.quote_phases_table.title')}
        </Text>
      </Box>
      <Table autoWidth>
        <Header isProductQuote={isProductQuote} />
        <Body
          standaloneItems={standaloneItems}
          currency={legalEntityMainCurrency}
          isProductQuote={isProductQuote}
          onUpdateStandaloneItem={handleUpdateStandaloneItem}
          onAddStandaloneItem={handleAddStandaloneItem}
          onDeleteStandaloneItem={handleDeleteStandaloneItem}
        />
      </Table>
    </>
  )
}

export default QuotePhasesTable
